import React, { useState } from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Divider,
  Box,
} from "@mui/material";
import k1 from "../assets/k1.png";
import k2 from "../assets/k2.png";
import k3 from "../assets/k3.png";
import s1 from "../assets/s1.png";
import s2 from "../assets/s2.png";
import s3 from "../assets/s3.png";
import color from "../assets/bannercolor.png";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { motion } from "framer-motion";
import GiftIcon from "@mui/icons-material/CardGiftcard";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PersonIcon from "@mui/icons-material/Person";
import LayersIcon from "@mui/icons-material/Layers";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import Header from "./Header";
import Footer from "./Footer";

const services = [
  { img: s1, title: "Horoscope" },
  { img: s2, title: "Mantras & Stotras" },
  { img: s3, title: "Religious Calendar" },
];

const categories = [
  {
    title: "Ceremonies",
    sub: ["Aksharabhyasam", "Annaprasana", "Marriage", "Naamakaranam"],
  },
  { title: "Homam", sub: ["Ganapathi Homam", "Navagraha Homam"] },
  { title: "Pariharam", sub: ["Dosha Nivarana", "Shanti Pooja"] },
  { title: "Poojas", sub: ["Satyanarayan Pooja", "Lakshmi Pooja"] },
  { title: "Ancestor-Rituals", sub: ["Tarpanam", "Shraddham"] },
  { title: "Donations", sub: [] },
  { title: "Japams", sub: [] },
];
const categoryCards = {
  Ceremonies: [
    { title: "Aksharabhyasam", img: k1 },
    { title: "Annaprasana", img: k2 },
    { title: "Marriage", img: k3 },
    { title: "Naamkaranam", img: k1 },
  ],
  Homam: [
    { title: "Ganapathi Homam", img: k2 },
    { title: "Navagraha Homam", img: k3 },
  ],
  Pariharam: [
    { title: "Dosha Nivarana", img: k1 },
    { title: "Shanti Pooja", img: k2 },
  ],
  Poojas: [
    { title: "Satyanarayan Pooja", img: k1 },
    { title: "Lakshmi Pooja", img: k2 },
  ],
  "Ancestor-Rituals": [
    { title: "Tarpanam", img: k3 },
    { title: "Shraddham", img: k1 },
  ],
  Donations: [{ title: "Annadanam", img: k2 }],
  Japams: [{ title: "Gayatri Japam", img: k3 }],
};
const primaryServices = [
  {
    icon: <GiftIcon sx={{ fontSize: 25, color: "#fff" }} />,
    name: "Gift A Puja",
    desc: "Gift A Puja to your Loved Ones",
  },
  {
    icon: <NotificationsIcon sx={{ fontSize: 25, color: "#fff" }} />,
    name: "Temple Services",
    desc: "Book a Puja Online in any of our listed Temples.",
  },
  {
    icon: <PersonIcon sx={{ fontSize: 25, color: "#fff" }} />,
    name: "Priest Services",
    desc: "Book a Priest online for any occasion, ritual and event.",
  },
  {
    icon: <LayersIcon sx={{ fontSize: 25, color: "#fff" }} />,
    name: "Pujas",
    desc: "Book a Puja Online in any of our listed Temples.",
  },
];
const devotionalservices = [
  {
    icon: <AutoStoriesIcon sx={{ fontSize: 50, color: "#B71C1C" }} />,
    title: "Astrology Basics",
    desc: "Learn the core principles of astrology in simple steps. Build a strong foundation to understand celestial influences on life.",
  },
  {
    icon: <BookOnlineIcon sx={{ fontSize: 50, color: "#B71C1C" }} />,
    title: "Vedic Astrology",
    desc: "Dive into the timeless wisdom of Vedic astrology. Discover traditions, methods, and insights passed down through generations.",
  },
  {
    icon: <TrackChangesIcon sx={{ fontSize: 50, color: "#B71C1C" }} />, // chart analysis = Advanced Kundli
    title: "Advanced Kundli Reading",
    desc: "Master the art of decoding birth charts with precision. Unlock deeper insights into destiny, relationships, and career.",
  },
];
const KarmKaand = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(categories[0].title);

  const handleCategoryClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);

    setSelectedCategory(categories[index].title);
  };

  const selectedCards = categoryCards[selectedCategory] || [];
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };
  const cardVariants = {
    hidden: { opacity: 0, scale: 0.5, y: 50 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <>
      <Header />
      <Grid container spacing={5} sx={{ p: { xs: 2, md: 6 }, mt: 10 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 0, md: 15 },
            width: "100%",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: { xs: 16, md: 22 },
                color: "#6d1675",
              }}
            >
              Primary Services
            </Typography>

            <Divider
              sx={{
                width: 100,
                borderBottomWidth: 5,
                borderColor: "#ffc20f",
                my: 2,
                mx: "auto",
              }}
            />
          </Box>
        </Box>
        {primaryServices.map((service, index) => (
          <Grid size={{ xs: 12, md: 3 }} key={index}>
            <Box
              sx={{
                p: 3,
                textAlign: "center",
                borderRadius: 2,
                boxShadow: 2,
                bgcolor: "#fff",
                minHeight: 150,
              }}
            >
              <Box
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: "50%",
                  bgcolor: "#6d1675",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                  ":hover": { bgcolor: "#ffc20f" },
                }}
              >
                {service.icon}
              </Box>
              <Typography sx={{ fontSize: 15, fontWeight: "bold" }}>
                {service.name}
              </Typography>
              <Typography sx={{ mt: 1, fontSize: 14 }}>
                {service.desc}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Grid
        variants={cardVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.2 }}
        container
        spacing={5}
        sx={{
          backgroundImage: `url(${color})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          // minHeight: { xs: "70vh", md: "100vh" },
          display: "flex",

          alignItems: "center",
          p: { xs: 2, md: 6 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            gap: { xs: 0, md: 15 },
            width: "100%",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: { xs: 16, md: 20 },
                color: "#6d1675",
              }}
            >
              Featured Courses
            </Typography>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: { xs: 24, md: 28 },
                mt: 1,
                lineHeight: 1.2,
                color: "#fff",
              }}
            >
              Begin your spiritual journey with expert-designed courses.
              <br /> Learn astrology step by step, from basics to advanced
              practices.
            </Typography>
            <Divider
              sx={{
                width: 100,
                borderBottomWidth: 5,
                borderColor: "#ffc20f",
                my: 2,
              }}
            />
          </Box>
        </Box>

        {devotionalservices.map((service, index) => (
          <Grid
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }}
            size={{ xs: 12, md: 4 }}
            key={index}
          >
            <motion.div
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.2 }}
            >
              <Card
                sx={{
                  textAlign: "center",
                  borderRadius: 2,
                  p: 3,
                  height: 270,
                  position: "relative",
                  overflow: "visible",
                  ":hover": {
                    bgcolor: "rgba(0, 0, 0, 0.7)",
                    color: "#fff",
                  },
                }}
              >
                <CardContent>
                  <Typography sx={{ mt: -2 }}>{service.icon}</Typography>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", mb: 2, mt: 2 }}
                  >
                    {service.title}
                  </Typography>
                  <Typography sx={{ mb: 3 }}>{service.desc}</Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        position: "absolute",
                        bottom: 30,
                        fontWeight: "bold",
                        color: "#B71C1C",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      KNOW MORE
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={5} sx={{ p: { xs: 2, md: 6 } }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            gap: { xs: 0, md: 15 },
            width: "100%",
            mb: 4,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: { xs: 16, md: 22 },
                color: "#6d1675",
              }}
            >
              Services
            </Typography>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: { xs: 16, md: 22 },
                color: "black",
              }}
            >
              Other Services
            </Typography>

            <Divider
              sx={{
                width: 100,
                borderBottomWidth: 5,
                borderColor: "#ffc20f",
                my: 2,
                mx: "auto",
              }}
            />
          </Box>
        </Box>

        {services.map((service, index) => (
          <Grid
            size={{xs:12,md:4}}
            key={index}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={service.img}
              alt={service.title}
              style={{ width: "90%", boxShadow: 5 }}
            />
            <Typography
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                mt: 2,
                fontSize: 20,
              }}
            >
              {service.title}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={5} sx={{ p: { xs: 2, md: 6 } }}>
        <Grid
          size={{ xs: 12, md: 3 }}
          sx={{ border: "1px solid #cccccc", boxShadow: 3, p: 2 }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
            Tamil Pooja Services
          </Typography>
          <Divider sx={{ borderColor: "#333", mt: -2 }} />

          <List component="nav">
            {categories.map((item, index) => (
              <React.Fragment key={index}>
                <ListItemButton
                  onClick={() => handleCategoryClick(index)}
                  sx={{
                    bgcolor:
                      selectedCategory === item.title
                        ? "#6d1675"
                        : "transparent",
                    color: selectedCategory === item.title ? "#fff" : "black",
                    "&:hover": { bgcolor: "#6d1675", color: "#fff" },
                  }}
                >
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: 1, p: 1 }}
                  >
                    {openIndex === index ? <ExpandLess /> : <ExpandMore />}
                    <Typography sx={{ fontWeight: "bold" }}>
                      {item.title}
                    </Typography>
                  </Box>
                </ListItemButton>

                <Divider />

                <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                  <List
                    component="div"
                    disablePadding
                    sx={{ bgcolor: "#f0f0f0" }}
                  >
                    {item.sub.map((subItem, i) => (
                      <React.Fragment key={i}>
                        <ListItemButton sx={{ pl: 4 }}>
                          <ArrowForwardIosIcon sx={{ fontSize: 14, mr: 1 }} />
                          <ListItemText primary={subItem} />
                        </ListItemButton>
                        {i !== item.sub.length - 1 && (
                          <Divider sx={{ borderColor: "#fff" }} />
                        )}
                      </React.Fragment>
                    ))}
                  </List>
                </Collapse>
              </React.Fragment>
            ))}
          </List>
        </Grid>
        <Grid
          component={motion.div}
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          key={selectedCategory}
          size={{ xs: 12, md: 9 }}
        >
          <Typography sx={{ mb: 2, fontWeight: "bold", fontSize: 25, mt: 2 }}>
            Select {selectedCategory} To Perform
          </Typography>

          <Grid container spacing={2}>
            {selectedCards.map((card, index) => (
              <Grid
                component={motion.div}
                variants={itemVariants}
                key={index}
                size={{ xs: 12, md: 3 }}
              >
                <Card
                  sx={{
                    cursor: "pointer",
                    textAlign: "center",
                    border: "1px solid #ddd",
                    "&:hover": { bgcolor: "#6d1675", color: "#fff" },
                  }}
                >
                  <CardMedia
                    component="img"
                    height="auto"
                    image={card.img}
                    alt={card.title}
                  />
                  <CardContent>
                    <Typography sx={{ fontSize: 16, fontWeight: "bold" }}>
                      {card.title}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
      
      <Footer />
    </>
  );
};

export default KarmKaand;

